import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageCropComponent } from './image-crop.component';

@NgModule({
  declarations: [ImageCropComponent],
  imports: [CommonModule],
  exports: [ImageCropComponent],
})
export class ImageCropModule {}
